import axiosInstance from '@/utils/api.js'

var state = {
  payments: []
}

var getters = {
  PAYMENTS: (state) => {
    return state.payments
  }
}

var mutations = {
  SET_PAYMENTS: (state, payload) => {
    state.payments = payload
  }
}

var actions = {
  GET_PAYMENTS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/payments?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&current_page=' + payload.currentPage +
    '&per_page=' + payload.perPage +
    '&filter=' + payload.filter +
    '&sort_field=' + payload.sortField +
    '&is_desc=' + payload.isDesc +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_PAYMENTS', result.data)
    }
  },
  GET_PAYMENTS_DOWNLOAD: async (context, payload) => {
    return axiosInstance.get('/reports/payments?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&current_page=' + payload.currentPage +
    '&per_page=' + payload.perPage +
    '&filter=' + payload.filter +
    '&sort_field=' + payload.sortField +
    '&is_desc=' + payload.isDesc +
    '&download=' + 1, {timeout: 45000})
  },
  CLEAR_PAYMENTS: (context) => {
    context.commit('SET_PAYMENTS', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/payments.js